export enum ChartTypeEnum {
  line,
  bar,
}
